import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { RootState, SliceDispatch } from './index'

// 在整个应用程序中使用，而不是简单的 `useDispatch` 和 `useSelector`
export const useAppDispatch: () => SliceDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
